
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ImportDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"import"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"transformedFilename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayedFilename"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}]},{"kind":"Field","name":{"kind":"Name","value":"fileType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fiduciary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"provider"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploadBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploadDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploadMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modifiedBy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"modifiedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"processingStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validationStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourcefiles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"processStartDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"processEndDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"processingTime"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}]},{"kind":"Field","name":{"kind":"Name","value":"totalRecords"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalRecordsFailed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalRecordsSuccessful"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"},"arguments":[]}]},{"kind":"Field","name":{"kind":"Name","value":"conflictingFunds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duplicateFunds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"missingIdentifierFunds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"invalidProductIdentifierFunds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unknownFunds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"successfulRecordsPerProduct"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"schemaErrorMessage"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":628}};
    doc.loc.source = {"body":"query ImportDetails($id: ID!) {\n  import(id: $id) {\n    id\n    transformedFilename\n    displayedFilename @client\n    fileType\n    fiduciary\n    provider\n    uploadBy\n    uploadDate\n    uploadMethod\n    modifiedBy\n    modifiedDate\n    processingStatus\n    validationStatus\n    sourcefiles {\n      name\n    }\n    processStartDate\n    processEndDate\n    processingTime @client\n    totalRecords\n    totalRecordsFailed\n    totalRecordsSuccessful @client\n    conflictingFunds\n    duplicateFunds\n    missingIdentifierFunds\n    invalidProductIdentifierFunds\n    unknownFunds\n    successfulRecordsPerProduct\n    schemaErrorMessage\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ImportDetails"] = oneQuery(doc, "ImportDetails");
        
